import { withSvgIcon } from './withSvgIcon';

export const Download = withSvgIcon(
  <>
    <path
      d="M7.5 10.5L12 15M12 15L16.5 10.5M12 15L12 5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M5 19H19"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
